import PropTypes from "prop-types";
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { Scrollbar } from "../../components/scrollbar";
import NoRecordFound from "../Table/NoRecordFound";
import { ROWS_PER_PAGE } from "../../utils/contsant";

const resolveRowKey = (rowKey, item, index) => {
  if (typeof rowKey === "function") {
    return rowKey(item, index);
  }

  return item?.[rowKey] ?? index;
};

function EntityTableCard({
  columns,
  count,
  items,
  onPageChange,
  onRowsPerPageChange,
  page,
  rowsPerPage,
  selected,
  rowKey,
  minWidth,
  headSx,
  paginationThreshold,
}) {
  const visibleColumns = columns.filter(Boolean);
  const startIndex = page * rowsPerPage;

  return (
    <Card>
      <Scrollbar forceVisible="y">
        <Box sx={{ minWidth }}>
          <Table>
            <TableHead sx={headSx}>
              <TableRow>
                {visibleColumns.map((column) => (
                  <TableCell
                    key={column.id || column.label}
                    align={column.align}
                    width={column.width}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item, index) => {
                const isSelected = selected.includes(item.id);
                const rowNumber = startIndex + index + 1;

                return (
                  <TableRow
                    hover
                    key={resolveRowKey(rowKey, item, index)}
                    selected={isSelected}
                  >
                    {visibleColumns.map((column) => (
                      <TableCell
                        key={column.id || column.label}
                        align={column.align}
                        width={column.width}
                      >
                        {column.render
                          ? column.render(item, {
                              index,
                              isSelected,
                              rowNumber,
                            })
                          : item?.[column.key]}
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <NoRecordFound data={items} />
        </Box>
      </Scrollbar>
      {count > paginationThreshold && (
        <TablePagination
          component="div"
          count={count}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={ROWS_PER_PAGE}
        />
      )}
    </Card>
  );
}

EntityTableCard.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  count: PropTypes.number,
  headSx: PropTypes.object,
  items: PropTypes.arrayOf(PropTypes.object),
  minWidth: PropTypes.number,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  page: PropTypes.number,
  paginationThreshold: PropTypes.number,
  rowKey: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  rowsPerPage: PropTypes.number,
  selected: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
};

EntityTableCard.defaultProps = {
  columns: [],
  count: 0,
  headSx: undefined,
  items: [],
  minWidth: 800,
  onPageChange: () => {},
  onRowsPerPageChange: () => {},
  page: 0,
  paginationThreshold: 10,
  rowKey: "id",
  rowsPerPage: 10,
  selected: [],
};

export default EntityTableCard;
